import type { GameStatus } from '../api';
import { GAME_STATUS_LABEL } from '../lib/skjutmeny';
import type { Theme } from '../theme';

// Symbolen före viltslaget i skjutmenyn (backlogg V2): grön = allt godkänt, måne = fel tid
// på dygnet, röd = slut i planen, ⊘ = utanför jakttid, ? = jakttid okänd.

export function GameStatusIcon({ status, T, size = 14, title }: { status: GameStatus; T: Theme; size?: number; title?: string }) {
  const label = title ?? GAME_STATUS_LABEL[status];
  const common = { width: size, height: size, viewBox: '0 0 16 16', role: 'img' as const, 'aria-label': GAME_STATUS_LABEL[status], style: { display: 'block', flexShrink: 0 } };
  if (status === 'lovligt') {
    return <svg {...common}><title>{label}</title><circle cx="8" cy="8" r="5" fill={T.ok} style={{ filter: `drop-shadow(0 0 3px ${T.ok})` }} /></svg>;
  }
  if (status === 'fel_tid') {
    return <svg {...common}><title>{label}</title><path d="M10.8 2.2A6 6 0 1 0 13.8 11 5 5 0 0 1 10.8 2.2Z" fill={T.amber} /></svg>;
  }
  if (status === 'slut') {
    return <svg {...common}><title>{label}</title><circle cx="8" cy="8" r="5" fill={T.danger} /></svg>;
  }
  if (status === 'ej_jakttid') {
    return <svg {...common}><title>{label}</title><circle cx="8" cy="8" r="5.5" fill="none" stroke={T.textMuted} strokeWidth="1.8" /><path d="M4.2 11.8 11.8 4.2" stroke={T.textMuted} strokeWidth="1.8" strokeLinecap="round" /></svg>;
  }
  return (
    <svg {...common}><title>{label}</title>
      <circle cx="8" cy="8" r="6" fill="none" stroke={T.textMuted} strokeWidth="1.5" strokeDasharray="2.2 1.6" />
      <text x="8" y="11.2" textAnchor="middle" fontSize="9" fontWeight="800" fill={T.textMuted} fontFamily="inherit">?</text>
    </svg>
  );
}

/** Förklaringen under skjutmenyn. */
export function GameStatusLegend({ T }: { T: Theme }) {
  const items: [GameStatus, string][] = [['lovligt', 'Lovligt nu'], ['fel_tid', 'Fel tid på dygnet'], ['slut', 'Slut i planen'], ['ej_jakttid', 'Utanför jakttid'], ['okand', 'Jakttid okänd']];
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 14px', color: T.textMuted, fontSize: 11, lineHeight: 1.4 }}>
      {items.map(([s, l]) => <span key={s} style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}><GameStatusIcon status={s} T={T} size={12} />{l}</span>)}
    </div>
  );
}
